import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LightingUpAngularModule } from "lighting-up-angular";
import { DonneesPatientCVModule } from "../../donnees-patient-cv/donnees-patient-cv.module";
import { DossierPatientModule } from "../../dossier-patient/dossier-patient.module";
import { PanneauCorrespondancesPatientsComponent } from "./panneau-correspondances-patients.component";

@NgModule({
	declarations: [PanneauCorrespondancesPatientsComponent],
	imports: [CommonModule, LightingUpAngularModule, DonneesPatientCVModule, DossierPatientModule],
	exports: [PanneauCorrespondancesPatientsComponent]
})
export class PanneauCorrespondancesPatientsModule { }

export { PanneauCorrespondancesPatientsComponent } from './panneau-correspondances-patients.component';
